module.exports = __webpack_public_path__ + "static/img/5879_phase_function_Paper_Points.19fb8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5879_phase_function_Paper_Points.png
// module id = 3LYh
// module chunks = 0